import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormStyled } from './Form.styled';
import { RatingField } from './RatingField';

interface FeedbackFieldFormProps {
  question: string;
  hint: string;
  name: string;
  value: string;
  onChange: any;
  color?: string;
  nameRating: string;
  onRateChange: (number: number) => void;
  selectNumber: number;
  errorScoreMessage?: string;
}

export const FeedbackFieldForm: React.FC<FeedbackFieldFormProps> = props => {
  const { t } = useTranslation();

  return (
    <div>
      <FormStyled.WrapperQuestionTitle>
        <FormStyled.Marker></FormStyled.Marker>
        <FormStyled.Question
          dangerouslySetInnerHTML={{
            __html: t(props.question)
          }}
        ></FormStyled.Question>
      </FormStyled.WrapperQuestionTitle>
      <FormStyled.RateContainer>
        <RatingField
          name={props.nameRating}
          number={1}
          text={t('Bad')}
          onRateChange={props.onRateChange}
          selectNumber={props.selectNumber}
        />
        <RatingField
          name={props.nameRating}
          number={2}
          onRateChange={props.onRateChange}
          selectNumber={props.selectNumber}
        />
        <RatingField
          name={props.nameRating}
          number={3}
          onRateChange={props.onRateChange}
          selectNumber={props.selectNumber}
        />
        <RatingField
          name={props.nameRating}
          number={4}
          onRateChange={props.onRateChange}
          selectNumber={props.selectNumber}
        />
        <RatingField
          name={props.nameRating}
          number={5}
          text={t('Great')}
          onRateChange={props.onRateChange}
          selectNumber={props.selectNumber}
        />
      </FormStyled.RateContainer>
      {props.errorScoreMessage && (
        <FormStyled.ValidationMessage>
          {props.errorScoreMessage}
        </FormStyled.ValidationMessage>
      )}
      <FormStyled.TextAreaField
        style={{ borderColor: props.color, marginTop: 16 }}
        value={props.value}
        onChange={props.onChange}
        name={props.name}
        placeholder={t(props.hint)}
      />
    </div>
  );
};
